export default "__VITE_ASSET__UYtAgVS$__"